import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';
import TagTabMainManagementContainer from '../../containers/tag/TagTabMainManagementContainer';

const TagTabMainManagement = () => {
  return (
    <PageTemplate pageName={TAG_PAGE_NAME.TAG_TAB_MAIN_MANAGEMENT}>
      <TagTabMainManagementContainer />
    </PageTemplate>
  );
};

export default TagTabMainManagement;
